<template>
    <div class="row m-1 mt-2" v-if="inheritanceFlow">
        <a ref="attachmentA"></a>
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col">
                            <router-link class="btn-link d-block" :to="{name:'route-index'}" v-if="!isuser">
                                <font-awesome-icon icon="arrow-circle-left"></font-awesome-icon> Elenco pratiche
                            </router-link>
                            <h1 class="mb-3">Modulo di segnalazione</h1>
                            <a href="../download/modulo.pdf" target="_blank" class="btn btn-sm btn-success mt-2 mb-2 d-none"> <font-awesome-icon :icon="getAttachmentIcon('test.pdf')" size="lg" /> Scarica modulo</a>
                            <form @submit.prevent="save">
                                <div class="form-group text-right mb-3">
                                    <button type="submit" class="btn btn-primary "><font-awesome-icon icon="save"></font-awesome-icon> Conferma</button>
                                </div>
                                <h3>Erede</h3>
                                <hr>
                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="col-form-label" for="name">Nome</label>
                                            <input type="text" class="form-control fullname" id="name" name="name" placeholder="Nome" v-model="inheritance.name">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="col-form-label" for="lastname">Cognome</label>
                                            <input type="text" class="form-control fullname" id="surname" name="surname" placeholder="Cognome" v-model="inheritance.surname">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="col-form-label" for="username">Telefono</label>
                                            <input type="text" class="form-control contact" id="phone" name="phone" placeholder="Telefono" v-model="inheritance.phone">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="col-form-label" for="email">Email</label>
                                            <input type="text" class="form-control contact" id="email" name="email" placeholder="Email" v-model="inheritance.email">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="col-form-label" for="fiscalCode">Codice fiscale</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.fiscalCode}}</p>
                                            <input type="text" class="form-control" id="fiscalCode" name="fiscalCode" placeholder="Codice Fiscale" v-model="inheritance.fiscalCode" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="col-form-label" for="birthDate">Data di nascita</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.birthDate | formatDate}}</p>
                                            <input type="date" class="form-control " id="birthDate" name="birthDate" placeholder="Data di nascita" v-model="inheritance.birthDate" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label class="col-form-label" for="birthCity">Comune di nascita</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.birthCity}}</p>
                                            <input type="text" class="form-control birthCity" id="birthCity" name="birthCity" placeholder="Comune di nascita" v-model="inheritance.birthCity" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="form-group">
                                            <label class="col-form-label" for="email">Provincia di nascita</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.birthDistrict}}</p>
                                            <input type="text" class="form-control birthDistrict" id="birthDistrict" name="birthDistrict" placeholder="Provincia di nascita" v-model="inheritance.birthDistrict" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="form-group">
                                            <label class="col-form-label" for="email">Nazione di nascita</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.birthCountry}}</p>
                                            <input type="text" class="form-control birthCountry" id="birthCountry" name="birthCountry" placeholder="Nazione di nascita" v-model="inheritance.birthCountry" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label class="col-form-label" for="birthCity">Comune di domicilio</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.city}}</p>
                                            <input type="text" class="form-control city" id="city" name="city" placeholder="Comune di nascita" v-model="inheritance.city" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="form-group">
                                            <label class="col-form-label" for="email">Provincia di domicilio</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.district}}</p>
                                            <input type="text" class="form-control district" id="district" name="district" placeholder="Provincia di domicilio" v-model="inheritance.district" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="form-group">
                                            <label class="col-form-label" for="email">Nazione di domicilio</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.country}}</p>
                                            <input type="text" class="form-control country" id="country" name="country" placeholder="Nazione di domicilio" v-model="inheritance.country" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label class="col-form-label" for="birthCity">Indirizzo di domicilio</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.address}}</p>
                                            <input type="text" class="form-control address" id="address" name="address" placeholder="Indirizzo di domicilio" v-model="inheritance.address" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label class="col-form-label" for="birthCity">CAP di domicilio</label>
                                            <p class="form-control-static" v-if="isReadOnly">{{inheritance.zipCode}}</p>
                                            <input type="text" class="form-control address" id="zipCode" name="zipCode" placeholder="CAP di domicilio" v-model="inheritance.zipCode" v-if="!isReadOnly">
                                        </div>
                                    </div>
                                </div>
                                <h3>Defunto</h3>
                                <hr>
                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="col-form-label" for="name">Nome</label>
                                            <input type="text" class="form-control deceaseName" id="deceaseName" name="deceaseName" placeholder="Nome" v-model="inheritance.deceaseName">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="col-form-label" for="lastname">Cognome</label>
                                            <input type="text" class="form-control deceaseSurname" id="deceaseSurname" name="deceaseSurname" placeholder="Cognome" v-model="inheritance.deceaseSurname">
                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-if="!isuser">
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label class="col-form-label" for="name">Codice fiscale</label>
                                            <input type="text" maxlength="16" class="form-control deceaseFiscalCode" id="deceaseFiscalCode" name="deceaseFiscalCode" placeholder="Codice fiscale" v-model="inheritance.deceaseFiscalCode">
                                        </div>
                                    </div>

                               
                                <div class="col-6">
                                    <div class="form-group">
                                        <label class="col-form-label" for="name">Data Decesso</label>
                                        <p class="form-control-static" v-if="isReadOnly">{{inheritance.deceaseDate | formatDate}}</p>
                                        <input type="date" class="form-control " id="deceaseDate" name="deceaseDate" placeholder="Data decesso" v-model="inheritance.deceaseDate" v-if="!isReadOnly">
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label class="col-form-label" for="lastname">Comune di nascita</label>
                                        <p class="form-control-static" v-if="isReadOnly">{{inheritance.deceaseCity}}</p>
                                        <input type="text" class="form-control deceaseCity" id="deceaseCity" name="deceaseCity" placeholder="Comune di nascita" v-model="inheritance.deceaseCity" v-if="!isReadOnly">
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-group">
                                        <label class="col-form-label" for="lastname">Provincia di nascita</label>
                                        <p class="form-control-static" v-if="isReadOnly">{{inheritance.deceaseDistrict}}</p>
                                        <input type="text" class="form-control deceaseDistrict" id="deceaseDistrict" name="deceaseCity" placeholder="Provinca di nascita" v-model="inheritance.deceaseDistrict" v-if="!isReadOnly">
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-group">
                                        <label class="col-form-label" for="lastname">Nazione</label>
                                        <p class="form-control-static" v-if="isReadOnly">{{inheritance.deceaseCountry}}</p>
                                        <input type="text" class="form-control deceaseCountry" id="deceaseCountry" name="deceaseCountry" placeholder="Nazione" v-model="inheritance.deceaseCountry" v-if="!isReadOnly">
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label class="col-form-label" for="name">Data di nascita</label>
                                        <p class="form-control-static" v-if="isReadOnly">{{inheritance.deceaseBirthdate | formatDate}}</p>
                                        <input type="date" class="form-control " id="deceaseBirthdate" name="deceaseBirthDate" placeholder="Data di nascita" v-model="inheritance.deceaseBirthdate" v-if="!isReadOnly">
                                    </div>
                                </div>
                        </div>
                        <!--<h3>Filiale</h3>
    <hr>-->
                        <div class="row d-none">
                            <div class="col">
                                <div class="form-group">
                                    <label class="col-form-label" for="name">Identificativo</label>
                                    <input type="text" class="form-control" id="externalCode" name="externalCode" placeholder="Identificativo" v-model="inheritance.externalCode">
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label class="col-form-label" for="lastname">Gestore</label>
                                    <input type="text" class="form-control" id="operator" name="operator" placeholder="Gestore" v-model="inheritance.operator">
                                </div>
                            </div>
                        </div>
                        <div class="row" v-for="r in inheritanceFlow.roles">

                            <div class="col-12" v-if="r.attachments.length>0">
                                <label class="col-form-label">Caricamento file</label>

                                <select class="form-control" id="attachmentType" ref="attachmenTypeId">
                                    <option v-for="a in r.attachments" :value="a.type.attachmentTypeId">{{a.type.name}} {{a.capacity>0?"(Obbligatiorio)":""}}</option>
                                </select>
                                <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions()" :useCustomSlot=true>
                                    <div class="dropzone-custom-content">
                                        <h3 class="dropzone-custom-title">Trascina il file qui</h3>
                                        <div class="subtitle">...o fai click per caricarlo dal tuo pc</div>
                                    </div>
                                </vue-dropzone>
                            </div>



                            <div class="col-12" v-for="a in r.attachments">
                                <div class="row">
                                    <div class="col" v-if="inheritance.attachments.filter(att=>att.attachmentTypeId == a.type.attachmentTypeId  && att.inheritanceId =='00000000-0000-0000-0000-000000000000').length>0">
                                        <label class="col-form-label" for="lastname">{{a.type.name}}</label>
                                        <div class="attachment row ml-2" v-for="file in inheritance.attachments.filter(att=>att.attachmentTypeId == a.type.attachmentTypeId  && att.inheritanceId =='00000000-0000-0000-0000-000000000000')">
                                            <div class="col-1">
                                                <font-awesome-icon :icon="getAttachmentIcon(file.originalFileName)" size="lg" class="text-primary" />
                                            </div>
                                            <div class="col-8">
                                                {{file.originalFileName}} <i>({{getAttachmentSize(file.weight)}})</i>
                                            </div>
                                            <div class="col-3 text-right">
                                                <button type="button" class="btn btn-link p-0" v-on:click="downloadAttachment(null,file.fileName,file.originalFileName)" title="Download"><font-awesome-icon icon="file-download" size="lg" class="text-info" /></button>
                                                <button type="button" class="btn btn-link p-0" v-on:click="removeAttachment(file.attachmentId,file.fileName)" title="Elimina risorsa"><font-awesome-icon :icon="['far','trash-alt']" size="lg" class="text-danger" /><i class=" fa-lg text-danger far fa-trash-alt"></i></button>
                                            </div>
                                        </div>


                                    </div>

                                </div>

                            </div>
                        </div>
                        <div class="form-group text-right mt-3">
                            <button type="submit" id="conferma" class="btn btn-primary "> <font-awesome-icon icon="save"></font-awesome-icon> Conferma</button>
                        </div>
                        </form>
                    </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- /.col -->
    </div>
</template>
<style>
    .row [class*='col'] {
        transition: all 0.5s ease-in-out;
    }
</style>
<script>
    import axios from 'axios'
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import moment from 'moment'

    export default {
        computed: {
            isuser: function () {
                console.log(this.$store.state.user)
                var u = false;

                for (var i = 0; i < this.$store.state.user.roles.length; i++) {
                    if (this.$store.state.user.roles[i] == "user" || this.$store.state.user.roles[i] =="superuser") {
                        u = true;
                        break;
                    }
                }

                return u;
            }
        },
        components: {
            vueDropzone: vue2Dropzone
        },
        data() {
            return {
                inheritanceFlow: null,
                inheritance: {
                    "inheritanceId": "00000000-0000-0000-0000-000000000000",
                    "authorityId": "00000000-0000-0000-0000-000000000000",
                    "agencyId": "00000000-0000-0000-0000-000000000000",
                    "userId": "00000000-0000-0000-0000-000000000000",
                    "date": null,
                    "state": 1,
                    "privacy01": true,
                    "externalCode": "",
                    "name": "",
                    "surname": "",
                    "email": "",
                    "phone": "",
                    "deceaseName": "",
                    "deceaseSurname": "",
                    "operator": "",
                    "attachments": []
                },

            }

        },
        name: 'InheritanceCreate',
        beforeMount() {
            document.body.classList.add('sidebar-minimized');
            document.body.classList.add('brand-minimized');


            this.inheritance.userId = this.$store.state.user.userId;
            this.inheritance.agencyId = this.$store.state.user.agencyId;
            this.inheritance.authorityId = this.$store.state.user.authorityId;
            //redirect solo landing di registrazione
            //this.$router.push({ name: 'route-register' });
            var me = this;
            this.$store
                .dispatch('inheritanceFlow', 0).then(response => {
                    me.inheritanceFlow = response.data.data;
                    // console.log(response);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        methods: {
            getAttachmentIcon: function (filename) {
                const regex = /[^\.]\w+$/gm;
                var result = regex.exec(filename);
                var ext = "." + result[0].toLowerCase();
                console.log(ext);
                switch (ext) {
                    case ".txt":
                        return ["far", "file-alt"];
                    case ".doc":
                    case ".docx":
                        return ["far", "file-word"];
                    case ".xls":
                    case ".xlsx":
                        return ["far", "file-excel"];
                    case ".csv":
                        return ["far", "file-csv"];
                    case ".jpg":
                    case ".jpeg":
                    case ".png":
                    case ".bmp":
                    case ".tiff":
                        return ["far", "file-image"];
                    case ".pdf":
                        return ["far", "file-pdf"];
                    case ".wav":
                    case ".mp3":
                        return ["far", "file-audio"];
                    case ".ppt":
                    case ".pptx":
                        return ["far", "file-powerpoint"];
                    case ".zip":
                    case ".rar":
                    case ".7z":
                        return ["far", "file-archive"];
                    default:
                        return ["far", "file"];

                }

            },

            getAttachmentSize: function (bytes) {
                var thresh = 1024;
                if (Math.abs(bytes) < thresh) {
                    return bytes + ' B';
                }
                var units = ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
                var u = -1;
                do {
                    bytes /= thresh;
                    ++u;
                } while (Math.abs(bytes) >= thresh && u < units.length - 1);
                return bytes.toFixed(1) + ' ' + units[u];
            },
            dropzoneOptions: function (typeid) {

                var me = this;
                function url() {

                    return window.SETTINGS.apiUrl + '/inheritances/uplaodattachment/' + me.$refs.attachmenTypeId[0].value+"/";
                }


                return {
                    url: url,
                    headers: { "Authorization": "Bearer " + this.$store.state.user.token },
                    success: function (a, b) {

                        
                        this.removeFile(a);
                        if (b.code == 200) {
                            me.inheritance.attachments.push(b.data);
                        }
                        else {
                              me.$swal('Attenzione', `<div class="text-danger font-weight-bold text-left">${b.message}</div>`, "error");
                        }
                    }
                }
            },
            downloadAttachment: function (id, f, o) {
                var me = this;
                var url = '';
                if (f) {
                    url = this.$filters.attachemntTempUrl(f, o);
                } else {
                    url = this.$filters.attachemntUrl(id);
                }
                axios.get(url, { responseType: 'blob' }).then(function (result) {
                    console.log(result);
                    var blob = new Blob([result.data], { type: result.headers["content-type"] });

                    me.$refs.attachmentA.href = URL.createObjectURL(blob)
                    me.$refs.attachmentA.download = o;
                    me.$refs.attachmentA.click()

                    // window.open(window.URL.createObjectURL(blob));
                });

            },
            removeAttachment: function (id, filename) {
                var me = this;
                me.$swal(
                    {
                        title: "Sicuri di voler eliminare l'allegato?",
                        text: "",
                        type: "question",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Procedi"
                    }

                ).then(function (isconfirm) {
                    if (isconfirm.value) {
                        axios.delete(`attachment?filename=${filename}`).then(function (r) {
                            me.inheritance.attachments = me.inheritance.attachments.filter(item => item.attachmentId !== id);
                            me.$swal(
                                {
                                    title: "Allegato cancellato correttamente",
                                    text: "",
                                    type: "success",
                                    showCancelButton: false,
                                    toast: true,
                                    timer: 2000,
                                    showConfirmButton: false,
                                    position: "bottom-end"
                                });
                        });
                    }
                });


            },
            save() {
                var me = this;
                this.inheritance.date = new moment();
                console.log("save");
                $('button[type="submit"]').attr('disabled',true);

             
                $('.form-control--danger').removeClass('form-control--danger');
                this.$store
                    .dispatch('inheritanceCreate', this.inheritance).then(response => {
                        if (response.status == 200) {
                            if (response.data.code != 200) {
                                var errors = [];
                                for (var i in response.data.data) {
                                    $('.' + i).addClass("form-control--danger");
                                    errors.push(response.data.data[i]);
                                }
                                me.$swal('Attenzione', `<div class="text-danger font-weight-bold text-left">${errors.join("<br/>")}</div>`, "error");
                                $('button[type="submit"]').attr('disabled',false);
                            }
                            else {
                                if (me.isuser) {
                                   
                                me.$store.state.inheritance = response.data.data.value.data;
                                    me.$router.push({ name: 'route-success-inheritance' });
                                }
                                else {
                                    me.$router.push({ name: 'route-index' });
                                }

                            }
                        }

                    })
                    .catch(error => {
                        console.log(error);
                    });
            }

        }
    };
</script>
















